<div class="settings-menu-item">
    <a class="menu-link" [title]="menuItem.title" [routerLink]="menuItem.routerLink">
        <mat-icon>{{menuItem.menuIcon}}</mat-icon>
        <span>{{menuItem.title}}</span>
    </a>
</div>
